import React from 'react';
import {
	TouchableOpacity,
	ActivityIndicator,
} from 'react-native';

import { Feather } from '@expo/vector-icons';

import Text from '../../text/Text';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useIsOnCard } from '../../../design/fieldSurface';
import { createPickerButtonStyles } from './PickerButton.styles';

const PickerButton = ({
	children,
	loading = false,
	disabled = false,
	style,
	onPress,
	accessibilityHint,
	accessibilityLabel,
	accessibilityRole,
}) => {
	const styles = useThemedStyles(createPickerButtonStyles);
	const isOnCard = useIsOnCard();

	return (
		<TouchableOpacity
			accessibilityHint={accessibilityHint}
			accessibilityLabel={accessibilityLabel}
			accessibilityRole={accessibilityRole}
			accessibilityState={{ disabled: Boolean(disabled), busy: Boolean(loading) }}
			style={[styles.button, isOnCard && styles.buttonOnCard, disabled && styles.disabled, style]}
			disabled={disabled}
			onPress={loading ? () => null : onPress}
		>
			{
				loading
					? <ActivityIndicator size="small" color={styles.label.color} />
					: (
						<>
							<Text style={[styles.label, disabled && styles.disabledLabel]}>
								{children}
							</Text>
							<Feather name="chevron-down" size={18} color={styles.icon.color} style={styles.icon} />
						</>
					)
			}

		</TouchableOpacity>
	);
};

export default PickerButton;
